import { createFileRoute, Link } from "@tanstack/react-router";
import { setCookie } from "@tanstack/react-start/server";
import * as oidc from "openid-client";
import { Button } from "@/components/ui/button";
import { getJumpcloudOidcConfig, newJumpcloudOidcPkce, redirectUri } from "@/lib/jumpcloud";
import { sign } from "@/lib/session-utils";

export const Route = createFileRoute("/auth/login")({
	component: Page,
	server: {
		handlers: {
			POST: async () => {
				const config = await getJumpcloudOidcConfig();
				const { codeVerifier, codeChallenge, state, nonce } = await newJumpcloudOidcPkce();

				const authorizeUrl = oidc.buildAuthorizationUrl(config, {
					redirect_uri: redirectUri,
					response_type: "code",
					scope: "openid profile email offline_access",
					code_challenge: codeChallenge,
					code_challenge_method: "S256",
					state,
					nonce,
				});

				const tmp = sign(JSON.stringify({ state, nonce, codeVerifier, t: Date.now() }));

				setCookie("jc_tmp", tmp, {
					httpOnly: true,
					secure: true,
					sameSite: "lax",
					maxAge: 5 * 60,
					path: "/",
				});

				return new Response(null, {
					status: 302,
					headers: { Location: authorizeUrl.toString() },
				});
			},
		},
	},
});

function Page() {
	return (
		<div className="flex min-h-screen flex-1 flex-col items-center justify-center">
			<form method="post" className="flex flex-col gap-6">
				<div className="flex flex-col items-center justify-center gap-2 text-center">
					<Link to="/" className="flex flex-col items-center gap-2 font-medium">
						<div className="mb-8 flex h-8 items-center justify-center rounded-md">
							<img
								src="/azerion-logo-dark.png"
								alt="Azerion Logo"
								className="hidden h-4 dark:block"
							/>
							<img src="/azerion-logo-light.png" alt="Azerion Logo" className="h-4 dark:hidden" />
						</div>
						<span className="sr-only">Azerion Podcast Backoffice</span>
					</Link>
					<h1 className="text-xl font-bold">Azerion Podcast Backoffice</h1>
				</div>

				<Button variant="outline" type="submit" className="w-full" size="lg">
					Continue with
					<img
						src="/jumpcloud-logo.svg"
						alt="JumpCloud Logo"
						className="mr-2 h-4 saturate-5 dark:invert"
					/>
				</Button>
			</form>
		</div>
	);
}
